import React from "react"
import styles from "./results.module.scss"

interface Props {
  title: string
  description: string
}

export default function Statistic(props: Props) {
  return (
    <div className={styles.square}>
      <span
        className="display1 script2"
        dangerouslySetInnerHTML={{ __html: props.title }}
      />
      <br />
      <span
        className="label1"
        dangerouslySetInnerHTML={{ __html: props.description }}
      />
    </div>
  )
}
